import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import "./DropDownMenu.css";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
export default function DropDownMenu(props) {
  const { menuList, anchorEl, onClose, handleMenuAction, disabled } = props;
  const theme = createMuiTheme({
    overrides: {
      MuiListItem: {
        button: {
          ":hover": {
            backgroundColor: "#757575",
          },
          ":focus": {
            backgroundColor: "#757575",
          },
        },
      },
      MuiMenu: {
        list: {
          color: "#ffffff",
          backgroundColor: "#757575 ",
          fontSize: "12px",
        },
      },
      popoverMenu: {
        backgroundColor: "#757575",
      },
    },
  });

  const renderMenuItems = (menu, index) => {
    return (
      <MenuItem
        key={index}
        onClick={() => handleMenuAction(menu)}
        className={"menuItem"}
        disabled={disabled || menu.disabled}
        // hidden={menu.hidden}
      >
        <span className={"pr-2 menuIcon"}>{menu.icon} </span> {menu.title}
      </MenuItem>
    );
  };

  return (
    <MuiThemeProvider theme={theme}>
      <Menu
        id="simple-menu1"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={onClose}
        className={"simpleMenu"}
      >
        {menuList !== undefined &&
          menuList.map((menu, index) => {
            return renderMenuItems(menu, index);
          })}
      </Menu>
    </MuiThemeProvider>
  );
}
